<template>

<div>

    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Företagskunder
        <a href="/companies/new" class="btn btn-default btn-sm">
          Lägg till företagskund
        </a>
    </h1>

    <div class="searchbar">

        <form>

            <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök företag, address, kontaktuppgifter" />
            </div>

            <div class="block" v-bind:class="{ active: search.status != null }">
                <label>
                    <select v-model="search.status" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Abonnemang</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.status != null }">
                <label>
                    <select v-model="search.status" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Status</option>
                        <option v-bind:value="1">Prospect</option>
                        <option v-bind:value="2">Aktiv</option>
                        <option v-bind:value="4">Avslutad</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.region_manager != null }">
                <label>
                    <select v-model="search.region_manager" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Avtalsansvarig</option>
                        <option v-bind:value="user.id" v-for="user in users">{{ user.name }}</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.contact_manager != null }">
                <label>
                    <select v-model="search.contact_manager" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Kontaktperson 1</option>
                        <option v-bind:value="user.id" v-for="user in users">{{ user.name }}</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.next_contact != null }">
                <label>
                    Nästa datum:
                    <select v-model="search.next_contact" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Alla användare</option>
                        <option v-bind:value="user.id" v-for="user in users">{{ user.name }}</option>
                    </select>
                </label>
            </div>

            <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right">
                <i class="fa fa-file" aria-hidden="true"></i> Spara excel
            </a>

            <br clear="all">

        </form>

    </div>

</div>

</template>

<script>

export default {
    props: {
        query: {
            required: true
        },
        loading: {}
    },
    data: function () {
        return {
            search: {
                text: ''
            }
        }
    },
    methods: {
        updateQuery: function () {
            this.$emit('search', this.search)
        }
    },
    watch: {
        query: function () {
            this.search = this.query
        }
    }
}

</script>
